// Posts thumbs-up / thumbs-down feedback for a bot message to the Adoption
// Enabler feedback endpoint.
export const callFeedbackAPI = async (
  proxyBase: string,
  messageId: string,
  sessionId: string,
  impression: string,
  feedbackText: string,
) => {
  try {
    const response = await fetch(`${proxyBase}/v1/adoptionAssistant/chats/feedback`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        "chatId": sessionId,
        "messageId": messageId,
        "feedback": {
          "type": "message",
          "impression": impression,
          "category": "Other",
          "details": feedbackText
        }
      }),
    });
    if (!response.ok) {
      console.error("Failed to send feedback:", response.statusText);
    } else {
      console.log("Feedback sent successfully");
    }
  } catch (error) {
    console.error("Error sending feedback:", error);
  }
};
